import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'batteryLastUpdated',
  standalone: false
})
export class BatteryLastUpdatedPipe implements PipeTransform {
  transform(lastReceived: Date | string | null | undefined, now: number): Date | null {
    if (lastReceived == null) return null;

    const received = new Date(lastReceived);
    const cutoff = new Date(now);
    cutoff.setDate(cutoff.getDate() - 1);
    cutoff.setHours(10, 0, 0, 0);
    if (Number.isNaN(received.getTime()) || received.getTime() >= cutoff.getTime()) {
      return null;
    }
    return received;
  }
}